export const noImage = '';
export const mapZoom = 12;
